import BaseService from '../../base/base_service';
import IEvolutionService from './evolution_service_interface';

interface IEvolutionServiceParams {
	useNewIntegration: boolean;
    supportOneStopShop: boolean;
}

export default class EvolutionService extends BaseService implements IEvolutionService {

    static CLASS = 'EvolutionService';

	private _params: IEvolutionServiceParams;

    init(params: IEvolutionServiceParams) {
		super.init(params);
		this._params = params;
	}

    shouldUseNewIntegration(): boolean {
        return this._params.useNewIntegration;
	}

    shouldUseOneStopShopIntegration(): boolean {
        return this._params.useNewIntegration && this._params.supportOneStopShop;
	}
}
